import styles  from './privacidade.module.css';

function Privacidade() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Política de Privacidade</h1>
        <p>Sua transparência e segurança são nossas prioridades.</p>
      </header>

      <main className={styles.content}>
        <section>
          <h2>Quais dados coletamos?</h2>
          <p>Para processar seus pedidos e garantir a melhor experiência, coletamos apenas o essencial:</p>
          <ul>
            <li><strong>Identificação:</strong> Nome completo e CPF.</li>
            <li><strong>Contato:</strong> E-mail e número de telefone.</li>
            <li><strong>Entrega:</strong> Endereço residencial ou comercial.</li>
          </ul>
        </section>

        <section>
          <h2>Como utilizamos seus dados?</h2>
          <p>
            Seus dados são utilizados exclusivamente para a emissão de notas fiscais, 
            processamento de entregas e comunicações sobre o status do seu pedido. 
            **Não vendemos nem compartilhamos seus dados com terceiros para fins publicitários.**
          </p>
        </section>

        <section>
          <h2>Parceiros e Processamento</h2>
          <p>Para garantir a segurança das suas transações e a logística das entregas, operamos com parceiros líderes de mercado:</p>
          
          <div className={styles.partnerCard}>
            <h3>Pagamentos: InfinitePay</h3>
            <p>Todo o processamento de pagamento é feito via <strong>InfinitePay</strong>. Não armazenamos seus dados de cartão de crédito em nossos servidores.</p>
          </div>

          <div className={styles.partnerCard}>
            <h3>Logística: Melhor Envio</h3>
            <p>Seu endereço e nome são compartilhados com o <strong>Melhor Envio</strong> apenas para a geração da etiqueta de postagem e transporte da mercadoria.</p>
          </div>
        </section>

        <section>
          <h2>Seus Direitos (LGPD)</h2>
          <p>Você tem total controle sobre seus dados. A qualquer momento, pode solicitar:</p>
          <ul>
            <li>Acesso e correção dos seus dados.</li>
            <li>A exclusão definitiva da sua conta e informações.</li>
            <li>Informações sobre como seus dados são tratados.</li>
          </ul>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>Última atualização: Março de 2026</p>
      </footer>
    </div>
  );
}

export default Privacidade;